export const getURLWithoutQueryParams = (url: string): string => {
  const [urlWithoutQueryParams] = url.split('?');
  return urlWithoutQueryParams;
};
